import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./slices/auth/authSlice";
import { translationSlice } from "./slices/translations/translationSlice";
import loginParamsSliceReducer from "./slices/loginParams/loginParams";

import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import persistReducer from "redux-persist/es/persistReducer";
import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE,
} from "redux-persist";

const loginParamsPersistedReducer = persistReducer(
    {
        key: "loginParams",
        storage,
    },
    loginParamsSliceReducer
);

const rootReducer = {
    auth: authSlice.reducer,
    translations: translationSlice.reducer,
    loginParams: loginParamsPersistedReducer,
};

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }),
});

export const persistor = persistStore(store);
